/* eslint-disable max-len */
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Button as MuiButton } from '@mui/material';

interface ButtonProps {
  variant?: 'outlined' | 'ghost' | 'contained';
  children: React.ReactNode;
  className?: string;
  [key: string]: any;
}

function Button({
  variant, children, className, ...rest
}: ButtonProps) {
  const baseStyles = 'py-2 px-4 rounded text-center transition-colors duration-300';
  const variantStyles = {
    outlined: 'border border-solid border-[#D9D9DB] text-[#000000] hover:bg-[#2065EC]/10 hover:border-[#2065EC] disabled:bg-[#2065EC]/50 disabled:text-white',
    ghost: 'bg-secondary text-[#00349A] hover:bg-[#00349A]/20 disabled:bg-[#00349A]/50 disabled:text-white',
    contained: 'bg-[#2065EC] hover:bg-blue-700 hover:bg-[#2065EC]/80 py-2 rounded w-fit text-white disabled:bg-[#2065EC]/50 disabled:text-white',
  };

  const combinedStyles = twMerge(baseStyles, variantStyles[variant as keyof typeof variantStyles], className);

  return (
    <MuiButton type="button" className={combinedStyles} {...rest}>
      {children}
    </MuiButton>
  );
}

Button.defaultProps = {
  variant: 'contained',
  className: '',
};

export default Button;
